import React, { useState, useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { get } from '../../services/apiController';
import { FloatingLabel, Form, Table, Row, Col } from 'react-bootstrap';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import { SlRefresh } from 'react-icons/sl';
import Breadcrumb from '../../components/Breadcrumb';
import moment from 'moment';

const CouponsView = () => {
  const [couponDetails, setCouponDetails] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const clickToDownload = useRef(null);
  const [companyList, setCompanyList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [state, setState] = useState({
    redeemStatus: '',
    companyId: '',
    dateFrom: '',
    dateTo: '',
    locationId: '',
  });

  const getCouponTrackerDetail = () => {
    try {
      get(
        `/cs/coupons-trackers/coupons-details/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&isRedeem=${state.redeemStatus}&companyId=${state.companyId}&locationId=${state.locationId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}`
      ).then((response) => {
        setCouponDetails(response?.data?.rows);
        setTotalRecords(response?.data?.count);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  const excelReport = () => {
    try {
      get(
        `/cs/coupons-trackers/coupons-details/?conditionType=download&isRedeem=${state.redeemStatus}&companyId=${state.companyId}&locationId=${state.locationId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}`
      ).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getCouponTrackerDetail();
      }
    },
    [state],
    DEBOUNCE_DELAY
  );

  function getCompanies() {
    try {
      get(`/cs/companies`).then((response) => {
        setCompanyList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getLocations() {
    try {
      get(`/branches`).then((response) => {
        setLocationList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useEffect(() => {
    getCompanies();
    getLocations();
  }, []);

  useEffect(() => {
    getCouponTrackerDetail();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Coupons' },
          { link: '#', title: 'Reports' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color " style={{ padding: '1rem 1.7rem' }}>
          <Col xs={2}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Coupons | {totalRecords ?? 0}
            </h4>
          </Col>
          <div className="col-10 d-flex align-items-center">
            <Row className="align-items-center">
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Location">
                  <Form.Select
                    value={state.locationId}
                    onChange={(e) => setState({ ...state, locationId: e.target.value })}
                    className="input"
                  >
                    <option value="">Select Location</option>
                    {locationList.map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={2}>
                <FloatingLabel controlId="floatingInput" label="Company">
                  <Form.Select
                    value={state.companyId}
                    onChange={(e) => setState({ ...state, companyId: e.target.value })}
                    className="input"
                    name="companyId"
                    placeholder="Company Id"
                  >
                    <option value="">Select Company</option>
                    {companyList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={2}>
                <FloatingLabel controlId="floatingInput" label="Valid From">
                  <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
                </FloatingLabel>
              </Col>
              <Col xs={2}>
                <FloatingLabel controlId="floatingInput" label="Valid To">
                  <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
                </FloatingLabel>
              </Col>
              <Col xs={2}>
                <FloatingLabel controlId="floatingInput" label="Redeem Status">
                  <Form.Select
                    value={state.redeemStatus}
                    onChange={(e) => setState({ ...state, redeemStatus: e.target.value })}
                    className="input me-3"
                  >
                    <option value="">Redeemed Status</option>
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={1} className="d-flex">
                <SlRefresh
                  className="text-primary"
                  style={{ width: '30px', height: '30px', cursor: 'pointer', marginRight: '10px' }}
                  onClick={() => setState({ ...state, redeemStatus: '', companyId: '', dateFrom: '', dateTo: '', locationId: '' })}
                />
                <GrDocumentExcel
                  title="Download excel"
                  style={{ cursor: 'pointer', width: '30px', height: '30px' }}
                  className="react-icons green"
                  onClick={excelReport}
                />
                <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
                  HiddenClick
                </a>
              </Col>
            </Row>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Company Name</th>
                    <th>Coupon Code</th>
                    <th>Coupon Value</th>
                    <th>Location</th>
                    <th>Customer</th>
                    <th>Customer Mobile</th>
                    <th>Redeemed?</th>
                    <th>Valid From</th>
                    <th>Valid Till</th>
                    <th>Used On</th>
                  </tr>
                </thead>
                <tbody>
                  {couponDetails.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item['Company.name'] ?? '-'}</td>
                        <td>{item?.couponCode}</td>
                        <td>₹ {item?.couponValue}</td>
                        <td>{item?.User?.Branch?.name ?? '-'}</td>
                        <td>{item['Customer.name'] ?? '-'}</td>
                        <td>{item['Customer.mobile'] ?? '-'}</td>
                        <td>{item?.usedOn ? 'Yes' : 'No'}</td>
                        <td>{moment(item?.validFrom).format('DD/MM/YY')}</td>
                        <td>{moment(item?.validTill).format('DD/MM/YY')}</td>
                        <td>{item?.usedOn ? moment(item.usedOn).format('DD/MM/YY hh:mm A') : '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CouponsView;
